import React from 'react';
import { Grid, Button, IconButton } from '@mui/material';
import * as Icon from '@mui/icons-material';

interface PecasTableProps {
  values: any;
  handleOpenPecasModal: () => void;
  setFieldValue: any
  duploClick?: boolean;
  edicaoRestrita: boolean;
}

const OrdemServicoPecas: React.FC<PecasTableProps> = ({ values, handleOpenPecasModal, setFieldValue, duploClick, edicaoRestrita }) => {

  const handleRemovePeca = (index: number) => {
    const updatedPecasJson = values.pecasjson.filter((_: any, i: any) => i !== index);
    setFieldValue('pecasjson', updatedPecasJson);
  };

  const handleEditItem = (index: number) => {
    const selectedPeca = values.pecasjson[index];
    setFieldValue('selectedPeca', selectedPeca);
    handleOpenPecasModal();
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '80%', margin: '0 auto' }}
    >
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOpenPecasModal}
            sx={{ mb: 2 }}
          >
            Adicionar Item
          </Button>
        </fieldset>
      </Grid>
      <Grid item xs={12}>
        <fieldset disabled={duploClick || edicaoRestrita}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Peça</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Quantidade</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Valor</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Desconto</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Valor Total</th>
                <th style={{ border: '1px solid #ccc', padding: '8px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {values.pecasjson.map((item: any, index: any) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.peca?.produto}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.peca?.quantidade}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.peca?.valorUnitario}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.peca?.desconto}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item?.peca?.valorTotal}</td>
                  <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                    <IconButton disabled={duploClick || edicaoRestrita} onClick={() => handleEditItem(index)} aria-label='edit' color='info' title='Editar'>
                      {' '}
                      <Icon.Edit />
                    </IconButton>
                    <IconButton color='error' onClick={() => handleRemovePeca(index)} disabled={duploClick || edicaoRestrita}>
                      <Icon.Delete />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>
      </Grid>
    </Grid>
  );
}

export default OrdemServicoPecas;
